type PageLocation = { pathname: string; searchStr: string };

/**
 * The initial page view is recorded when the activity tracker starts. Router
 * subscriptions may begin before OR after the initial onResolved event, so
 * deduplicate by location instead of unconditionally dropping the first event.
 * A return to a previously visited page is still a new page view.
 */
export function createPageViewNavigation(
  initialPath: string,
  onPageChange: (path: string) => void,
): (event: { toLocation: PageLocation }) => void {
  let lastPath = initialPath;
  return ({ toLocation }) => {
    const path = toLocation.pathname + toLocation.searchStr;
    if (path === lastPath) return;
    lastPath = path;
    onPageChange(path);
  };
}
